

















import Vue from 'vue';

export default Vue.extend({
  props: {
    initialNote: String as () => string | null,
    taskId: String as () => string | null,
  },

  data() {
    return {
      value: this.initialNote,
    };
  },

  watch: {
    initialNote(val: string | null) {
      this.value = val;
    },
  },
});
